import type { FieldReadFunction } from '@apollo/client';

export const fieldToLowerCase: FieldReadFunction = (field?: string | null) => {
    return field ? field.toLowerCase() : field;
};
